import React, { useEffect, useState, useCallback, useRef } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import "./App.css";
import "./MainMenu.css";
import TagManager from "react-gtm-module";
import { useAuth0 } from "@auth0/auth0-react";
import GlobalLoadingSpinner from "./components/GlobalLoadingSpinner";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import * as Images from "./themes/images";

//VIEWS
import Home from "./views/Home";
import Dashboard from "./views/Dashboard";

// import AdminDashboard from "./views/AdminDashboard";

import Administrator from "./views/Administrator";
import AdministratorSingle from "./views/Administrator/AdministratorSingle";
import XeroSettings from "./views/XeroSettings";
import CoffeePassBills from "./views/CoffeePassBills";
import { shouldShowXeroHealth, XeroHealthBannerHost } from "./components/XeroIntegrationHealth";

import PartnerCompany from "./views/PartnerCompany";
import PartnerCompanySingle from "./views/PartnerCompany/PartnerCompanySingle";

import PartnerUsers from "./views/PartnerCompany/PartnerUser";
// import PartnerPricing from "./views/PartnerCompany/PartnerPricing";
import MerchantAccount from "./views/MerchantAccount";
import MerchantAccountSingle from "./views/MerchantAccount/SingleAccount";
import MerchantUserSingle from "./views/MerchantAccount/SingleAccount/merchantUsers/User";
import Maintenance from "./views/Maintenance";
import NotFound from "./views/404";
import ReactGA from "react-ga4";
import { api } from "./utils/api";
import axios from "axios";
import { getCurrentP1Region } from "./utils/p1Region";
import {
  AUTH0_API_AUDIENCE,
  isPublicAppPath,
  shouldRedirectToLogin,
  syncSessionAccessToken,
} from "./utils/sessionAccessToken";
// import { Dashboard } from "@mui/icons-material";
import SelectPortalDD from "./components/SelectPortalDD";
import SelectPortalModal from "./components/SelectPortalModal";
import SelectCompanyModal from "./components/SelectCompanyModal";
// import SelectCompanyDD from "./components/SelectCompanyDD";
import MainMenu from "./components/MainMenu";
import GlobalFooter from "./components/GlobalFooter";
import { Profile } from "./components";
import RegionPortalSwitcher from "./components/RegionPortalSwitcher";
import PartnerUserSingle from "./views/PartnerCompany/PartnerUser/PartnerUserSingle";
import Product from "./views/Product";
import ProductSingle from "./views/Product/ProductSingle";
import PartnerPricing from "./views/PartnerPricing";
import PartnerPricingSingle from "./views/PartnerPricing/PartnerPricingSingle";
import MerchantStorePricing from "./views/MerchantStorePricing";
import MerchantStorePricingSingle from "./views/MerchantStorePricing/MerchantStorePricingSingle";
import Subscription from "./views/Subscription";
import SubscriptionSingle from "./views/Subscription/SubscriptionSingle";
import CreateMembership from "./views/Subscription/CreateMembership";
import UpdateSubscriptionPrices from "./views/Subscription/UpdateSubscriptionPrices";
import MembershipAnalytics from "./views/MembershipAnalytics";
import Vehicle from "./views/Vehicle";
import VehicleSingle from "./views/Vehicle/VehicleSingle";
import Customer from "./views/Customer";
import Communications from "./views/Communications";
import AdminLogs from "./views/AdminLogs";
import CustomerSingle from "./views/Customer/CustomerSingle";
import FindAndMergeMemberships from "./views/Customer/FindAndMergeMemberships";
import Logout from "./views/Customer/Logout";
import Login from "./views/Customer/Login";
import InviteCode from "./views/InviteCode";
import InviteCodeSingle from "./views/InviteCode/InviteCodeSingle";
import Transaction from "./views/Transaction";
import TransactionSingle from "./views/Transaction/TransactionSingle";
import Promotion from "./views/Promotion";
import PromotionSingle from "./views/Promotion/PromotionSingle";
import Redemption from "./views/Redemption";
import RedemptionSingle from "./views/Redemption/RedemptionSingle";
import MerchantStoreSingle from "./views/MerchantAccount/SingleAccount/merchantStores/Store";
// import useCookies from "react-cookie/cjs/useCookies";
import SignupCustomer from "./views/SignupCustomer";
import ActivateMembershipWithInviteCode from "./views/ActivateMembershipWithInviteCode";
import MerchantStoreMap from "./views/Locations/MerchantStoreMap";
import MySubscriptions from "./views/MySubscritptions";
import MyAccount from "./views/MyAccount";
import { ErrorMessage } from "formik";
import CurrentWashLocationsMap from "./views/CurrentWashLocationsMap";
import MerchantStore from "./views/MerchantStore";
import SelfSignUp from "./views/SelfSignUp";
import SelfSignUpRegister from "./views/SelfSignUp/register";
import SelfSignUpSuccess from "./views/SelfSignUp/success";
import SelfSignUpCancel from "./views/SelfSignUp/cancel";
import PendingVehicleActivationModal from "./components/PendingVehicleActivationModal";
import { isCurrentEmbedAllowed, isPublicEmbedPath } from "./config/publicEmbed";

const App = () => {
  // useEffect(() => {
  //   const xeroApiRecord = api(`v1/xeroapi`);
  // });
  // const xeroApiRecord = api(`v1/xeroapi`);
  const blueLogo = Images.blueLogo;
  const P1LogoLight = Images.globalLogoSmall;
  const [currentUser, setCurrentUser] = useState();
  const { isLoading, user, logout, getAccessTokenSilently, isAuthenticated, loginWithRedirect } = useAuth0();
  const authRedirectStarted = useRef(false);

  useEffect(() => {
    // TODO: REMOVE A SESSION ON ACTIVATION TO MAKE SURE YOU'RE STARTING FRESH

    // console.log("LOC: ", window.location.href);
    // if (window.location.href.indexOf("/activate") > -1) {
    //   console.log("WILL LOG OUT");
    //   sessionStorage.removeItem("currentUser");
    //   logout({ returnTo: window.location.href });
    // }

    if (sessionStorage.getItem("currentUser")) {
      console.log("Session ma: ", JSON.parse(sessionStorage.getItem("currentUser")), "CURRENTUSER:", currentUser);
      setCurrentUser(JSON.parse(sessionStorage.getItem("currentUser")));
    }
  }, [sessionStorage.getItem("currentUser")]);

  const [isOffline, setIsOffline] = useState(false);

  if (!user) {
    sessionStorage.removeItem("currentUser");
  }
  const [userPortals, setUserPortals] = useState([]);

  const [currentPortal, setCurrentPortal] = useState(null);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [currentMerchantStore, setCurrentMerchantStore] = useState(null);
  const [pendingVehicleItems, setPendingVehicleItems] = useState([]);
  const [pendingVehicleActivationItems, setPendingVehicleActivationItems] = useState([]);

  // Store an audience-scoped Auth0 access token for API calls.
  // Do not touch sessionStorage while Auth0 is still loading: `user` is empty
  // during that window, including right after the AU|NZ full-page switch.
  useEffect(() => {
    if (isPublicEmbedPath(window.location.pathname)) return undefined;
    let cancelled = false;
    const storeAuthToken = async () => {
      const result = await syncSessionAccessToken({
        isLoading,
        user,
        getAccessTokenSilently,
      });
      let embedded = false;
      try {
        embedded = window.self !== window.top;
      } catch (_frameError) {
        embedded = true;
      }
      if (
        cancelled ||
        authRedirectStarted.current ||
        !shouldRedirectToLogin({
          result,
          pathname: window.location.pathname,
          embedded,
        })
      ) {
        return;
      }
      authRedirectStarted.current = true;
      try {
        await loginWithRedirect({
          authorizationParams: {
            audience: AUTH0_API_AUDIENCE,
            redirect_uri: window.location.origin,
          },
        });
      } catch (error) {
        authRedirectStarted.current = false;
        console.error("Error redirecting to Auth0 login:", error);
      }
    };
    storeAuthToken();
    return () => {
      cancelled = true;
    };
  }, [isLoading, user, getAccessTokenSilently, loginWithRedirect]);

  useEffect(() => {
    if (isPublicEmbedPath(window.location.pathname)) return undefined;

    const checkHealth = async () => {
      try {
        const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
        const hostname = window.location.hostname;
        const isNzRegion = getCurrentP1Region() === "NZ";

        // Determine API domain based on environment
        // Staging branch uses staging API for all non-localhost deployments
        let domain;
        if (isLocalhost) {
          domain = "http://localhost:8095/";
        } else if (isNzRegion) {
          domain = "https://api.priorityonewashclub.co.nz/";
        } else if (
          hostname.includes("staging.dm6wsofv5048b.amplifyapp.com") ||
          hostname.includes("dm6wsofv5048b.amplifyapp.com") ||
          hostname.includes("p1-staging") ||
          !hostname.includes("priorityonewashclub.com") // If it's not the production domain, use staging
        ) {
          // Staging environment - use staging API
          domain = "https://p1-staging-api.priorityonewashclub.com/";
        } else {
          // Production domain - use production API
          domain = "https://api.priorityonewashclub.com/";
        }

        let health = await axios.get(domain);
        // console.log("Health :", health);
        if (health.status !== 200) {
          setIsOffline(true);
        }
      } catch (error) {
        setIsOffline(true);
      }
    };

    const fetchUserPortals = async () => {
      try {
        const { email } = user;
        const response = await api(`v1/initialFetch/portals/${email}`, "GET");
        if (response.data.success) {
          const { portals = [], pendingActivation, activationUrl } = response.data.data || {};

          if (portals.length > 0) {
            setUserPortals(portals);
          } else if (pendingActivation && activationUrl) {
            const currentUrl = window.location.href.replace(/\/$/, "");
            const targetUrl = activationUrl.replace(/\/$/, "");
            const onActivationPage = window.location.pathname.includes("/activate");

            if (!onActivationPage && currentUrl !== targetUrl) {
              window.location.href = activationUrl;
            } else {
              alert(
                `We found your Priority One account, but it still needs activation. Please complete the activation form to get started.`
              );
            }
          } else {
            alert(
              `There are no accounts associated with the email you are currently using (${email}), please contact support.`
            );
            logout({ logoutParams: { returnTo: window.location.origin } });
          }
        }
      } catch (error) {
        setIsOffline(true);
        console.log("No data received");
      }
    };

    // Public pages (location map, signup, activation) must not look up portals.
    // A stale Auth0 session would otherwise alert, log the visitor out, or
    // send the marketing-site iframe to an activation URL.
    if (!isPublicAppPath(window.location.pathname)) {
      fetchUserPortals();
    }
    checkHealth();
  }, [user]); // Depend on the 'user' object to trigger the fetch

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        // Wait for Auth0; avoid destructuring undefined user (was breaking this effect on cold load).
        if (isLoading || !isAuthenticated || !user?.email || !currentPortal) {
          return;
        }
        const { email } = user;
        const response = await api(`v1/initialFetch/${currentPortal}/${email}`, "GET");
        if (response.data.success) {
          setIsOffline(false);
          setCurrentUser(response.data.data.userInfo);
          sessionStorage.setItem("currentUser", JSON.stringify(response.data.data.userInfo));
          console.log("Session Set", JSON.stringify(response.data.data.userInfo));

          // For customers, check and create missing contracts on login / portal load
          if (currentPortal === "Customer" && response.data.data.userInfo._id) {
            try {
              console.log("🔍 Checking for missing contracts on login for customer:", response.data.data.userInfo._id);
              const contractCheckResponse = await api(
                `v1/contract/check-and-create/${response.data.data.userInfo._id}`,
                "POST"
              );
              if (contractCheckResponse.data.success) {
                console.log("✅ Contract check completed:", contractCheckResponse.data.data);
                if (contractCheckResponse.data.data.contractsCreated > 0) {
                  console.log(
                    `📝 Created ${contractCheckResponse.data.data.contractsCreated} missing contract(s) on login`
                  );
                }
              }
            } catch (contractError) {
              console.error("Error checking contracts on login:", contractError);
              // Don't block login if contract check fails
            }
          }
        }
      } catch (error) {
        setIsOffline(true);
        console.log("No data received");
      }
    };
    fetchUserInfo();
  }, [currentPortal, user?.email, isLoading, isAuthenticated]);

  const loadPendingVehicleFlows = useCallback(async () => {
    if (!user?.email || currentPortal !== "Customer") {
      setPendingVehicleItems([]);
      setPendingVehicleActivationItems([]);
      return;
    }
    sessionStorage.setItem("authEmail", user.email.toLowerCase().trim());

    let token = sessionStorage.getItem("token");
    if (!token) {
      try {
        token = await getAccessTokenSilently();
        sessionStorage.setItem("token", token);
      } catch (e) {
        setPendingVehicleItems([]);
        setPendingVehicleActivationItems([]);
        return;
      }
    }
    try {
      const captureRes = await api("v1/customer/me/pending-vehicle-details", "GET");
      const captureItems =
        captureRes.data?.success && Array.isArray(captureRes.data.data?.items)
          ? captureRes.data.data.items
          : [];
      setPendingVehicleItems(captureItems);

      if (captureItems.length > 0) {
        setPendingVehicleActivationItems([]);
        return;
      }

      const activationRes = await api("v1/customer/me/pending-vehicle-activations", "GET");
      if (
        activationRes.data?.success &&
        Array.isArray(activationRes.data.data?.items) &&
        activationRes.data.data.items.length > 0
      ) {
        setPendingVehicleActivationItems(activationRes.data.data.items);
      } else {
        setPendingVehicleActivationItems([]);
      }
    } catch (e) {
      console.error("Failed to load pending vehicle flows:", e);
      setPendingVehicleItems([]);
      setPendingVehicleActivationItems([]);
    }
  }, [user, user?.email, currentPortal, getAccessTokenSilently]);

  useEffect(() => {
    loadPendingVehicleFlows();
  }, [loadPendingVehicleFlows]);

  const handlePendingVehicleFlowResolved = useCallback(
    async ({ mode } = {}) => {
      await loadPendingVehicleFlows();
      if (mode === "activation") {
        try {
          const userInfo = JSON.parse(sessionStorage.getItem("currentUser") || "{}");
          if (userInfo._id) {
            await api(`v1/contract/check-and-create/${userInfo._id}`, "POST");
          }
        } catch (e) {
          console.error("Contract check after vehicle activation failed:", e);
        }
      }
    },
    [loadPendingVehicleFlows]
  );

  // Create a function to generate routes dynamically based on available portals
  const generateRoutes = () => {
    const routes = [];
    const addPortalRoutes = (portal, portalRoutes) => {
      routes.push(portalRoutes.map((route) => <Route key={route.props.path} {...route.props} />));
    };
    // Check available portals and add corresponding routes
    if (userPortals.includes("Administrator") && currentPortal === "Administrator") {
      addPortalRoutes("Administrator", [
        <Route
          exact
          path="/dashboard"
          Component={withAuthenticationRequired(Dashboard, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,

        // <Route
        //   exact
        //   path="/dashboard"
        //   element={withAuthenticationRequired(AdminDashboard, {
        //     onRedirecting: () => <GlobalLoadingSpinner />
        //   })}
        // />,
        <Route
          exact
          path="/administrator"
          Component={withAuthenticationRequired(Administrator, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/administrator/:idAdministrator"
          Component={withAuthenticationRequired(AdministratorSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/product"
          Component={withAuthenticationRequired(Product, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/product/:idProduct"
          Component={withAuthenticationRequired(ProductSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partnerPricing"
          Component={withAuthenticationRequired(PartnerPricing, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partnerPricing/:idPartnerPricing"
          Component={withAuthenticationRequired(PartnerPricingSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchantStorePricing"
          Component={withAuthenticationRequired(MerchantStorePricing, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchantStorePricing/:idMerchantStorePricing"
          Component={withAuthenticationRequired(MerchantStorePricingSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription"
          Component={withAuthenticationRequired(Subscription, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription/create-membership"
          Component={withAuthenticationRequired(CreateMembership, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription/update-prices"
          Component={withAuthenticationRequired(UpdateSubscriptionPrices, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/membership-analytics"
          Component={withAuthenticationRequired(MembershipAnalytics, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription/:idSubscription"
          Component={withAuthenticationRequired(SubscriptionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle"
          Component={withAuthenticationRequired(Vehicle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle/:idVehicle"
          Component={withAuthenticationRequired(VehicleSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partner"
          Component={withAuthenticationRequired(PartnerCompany, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partner/:id"
          Component={withAuthenticationRequired(PartnerCompanySingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partner/:idPartnerCompany/user/:idUser"
          Component={withAuthenticationRequired(PartnerUserSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchant"
          Component={withAuthenticationRequired(MerchantAccount, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchantStore"
          Component={withAuthenticationRequired(MerchantStore, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchant/:id"
          Component={withAuthenticationRequired(MerchantAccountSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchant/:idMerchant/user/:idUser"
          Component={withAuthenticationRequired(MerchantUserSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchant/:idMerchant/store/:idStore"
          Component={withAuthenticationRequired(MerchantStoreSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/customer"
          Component={withAuthenticationRequired(Customer, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/communications"
          Component={withAuthenticationRequired(Communications, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/admin/logs"
          Component={withAuthenticationRequired(AdminLogs, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/customer/find-merge"
          Component={withAuthenticationRequired(FindAndMergeMemberships, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/customer/:idCustomer"
          Component={withAuthenticationRequired(CustomerSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/promotion"
          Component={withAuthenticationRequired(Promotion, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/promotion/:idPromotion"
          Component={withAuthenticationRequired(PromotionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/redemption"
          Component={withAuthenticationRequired(Redemption, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/redemption/:idRedemption"
          Component={withAuthenticationRequired(RedemptionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/transaction"
          Component={withAuthenticationRequired(Transaction, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/transaction/:idTransaction"
          Component={withAuthenticationRequired(TransactionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/inviteCode"
          Component={withAuthenticationRequired(InviteCode, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/inviteCode/:idInviteCode"
          Component={withAuthenticationRequired(InviteCodeSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/my-account"
          Component={withAuthenticationRequired(MyAccount, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/xero"
          Component={withAuthenticationRequired(XeroSettings, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/coffee-pass-bills"
          Component={withAuthenticationRequired(CoffeePassBills, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />
        // Add other routes for the Administrator portal here
      ]);
    }

    if (userPortals.includes("Merchant") && currentPortal === "Merchant") {
      addPortalRoutes("Merchant", [
        <Route
          exact
          path="/dashboard"
          Component={withAuthenticationRequired(Dashboard, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        // <Route
        //   exact
        //   path="/dashboard"
        //   element={withAuthenticationRequired(<AdminDashboard />, {
        //     onRedirecting: () => <GlobalLoadingSpinner />
        //   })}
        // />,
        <Route
          exact
          path="/customer"
          Component={withAuthenticationRequired(Customer, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/customer/:idCustomer"
          Component={withAuthenticationRequired(CustomerSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle"
          Component={withAuthenticationRequired(Vehicle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle/:idVehicle"
          Component={withAuthenticationRequired(VehicleSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchantStore"
          Component={withAuthenticationRequired(MerchantStore, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchantStore/:idStore"
          Component={withAuthenticationRequired(MerchantStoreSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/merchantStore/:idStore"
          Component={withAuthenticationRequired(MerchantStoreSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/redemption"
          Component={withAuthenticationRequired(Redemption, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/redemption/:idRedemption"
          Component={withAuthenticationRequired(RedemptionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/product/:idProduct"
          Component={withAuthenticationRequired(ProductSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/my-account"
          Component={withAuthenticationRequired(MyAccount, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />
        // Add other routes for the Administrator portal here
      ]);
      if (currentUser.role == "admin") {
        addPortalRoutes("Merchant", [
          <Route
            exact
            path="/merchant"
            Component={withAuthenticationRequired(MerchantAccount, {
              onRedirecting: () => <GlobalLoadingSpinner />
            })}
          />,
          <Route
            exact
            path="/merchant/:id"
            Component={withAuthenticationRequired(MerchantAccountSingle, {
              onRedirecting: () => <GlobalLoadingSpinner />
            })}
          />,
          <Route
            exact
            path="/merchant/:idMerchant/user/:idUser"
            Component={withAuthenticationRequired(MerchantUserSingle, {
              onRedirecting: () => <GlobalLoadingSpinner />
            })}
          />,
          <Route
            exact
            path="/merchant/:idMerchant/store/:idStore"
            Component={withAuthenticationRequired(MerchantStoreSingle, {
              onRedirecting: () => <GlobalLoadingSpinner />
            })}
          />,
          <Route
            exact
            path="/product"
            Component={withAuthenticationRequired(Product, {
              onRedirecting: () => <GlobalLoadingSpinner />
            })}
          />,
          <Route
            exact
            path="/product/:idProduct"
            Component={withAuthenticationRequired(ProductSingle, {
              onRedirecting: () => <GlobalLoadingSpinner />
            })}
          />
        ]);
      }
    }

    if (userPortals.includes("Partner") && currentPortal === "Partner") {
      addPortalRoutes("Partner", [
        <Route
          exact
          path="/dashboard"
          Component={withAuthenticationRequired(Dashboard, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/signup-customer"
          Component={withAuthenticationRequired(SignupCustomer, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        // <Route
        //   exact
        //   path="/dashboard"
        //   element={withAuthenticationRequired(<AdminDashboard />, {
        //     onRedirecting: () => <GlobalLoadingSpinner />
        //   })}
        // />,
        <Route
          exact
          path="/product"
          Component={withAuthenticationRequired(Product, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/product/:idProduct"
          Component={withAuthenticationRequired(ProductSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partnerPricing"
          Component={withAuthenticationRequired(PartnerPricing, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partnerPricing/:idPartnerPricing"
          Component={withAuthenticationRequired(PartnerPricingSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription"
          Component={withAuthenticationRequired(Subscription, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription/:idSubscription"
          Component={withAuthenticationRequired(SubscriptionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle"
          Component={withAuthenticationRequired(Vehicle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle/:idVehicle"
          Component={withAuthenticationRequired(VehicleSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partner"
          Component={withAuthenticationRequired(PartnerCompany, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partner/:id"
          Component={withAuthenticationRequired(PartnerCompanySingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/partner/:idPartnerCompany/user/:idUser"
          Component={withAuthenticationRequired(PartnerUserSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/customer"
          Component={withAuthenticationRequired(Customer, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/customer/:idCustomer"
          Component={withAuthenticationRequired(CustomerSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/promotion"
          Component={withAuthenticationRequired(Promotion, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/promotion/:idPromotion"
          Component={withAuthenticationRequired(PromotionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/redemption/:idRedemption"
          Component={withAuthenticationRequired(RedemptionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/transaction"
          Component={withAuthenticationRequired(Transaction, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/transaction/:idTransaction"
          Component={withAuthenticationRequired(TransactionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/my-account"
          Component={withAuthenticationRequired(MyAccount, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/self-signup-customer"
          Component={withAuthenticationRequired(SelfSignUp, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />
        // Add other routes for the Administrator portal here
      ]);
    }

    if (userPortals.includes("Customer")) {
      addPortalRoutes("Customer", [
        <Route
          exact
          path="/Login"
          Component={withAuthenticationRequired(Login, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/my-subscriptions"
          Component={withAuthenticationRequired(MySubscriptions, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/map"
          element={withAuthenticationRequired(<MerchantStoreMap />, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/subscription/:idSubscription"
          Component={withAuthenticationRequired(SubscriptionSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle"
          Component={withAuthenticationRequired(Vehicle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/vehicle/:idVehicle"
          Component={withAuthenticationRequired(VehicleSingle, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/logout"
          Component={withAuthenticationRequired(Logout, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />,
        <Route
          exact
          path="/my-account"
          Component={withAuthenticationRequired(MyAccount, {
            onRedirecting: () => <GlobalLoadingSpinner />
          })}
        />
        // Add other routes for the Customer portal here
      ]);
    }

    // Add other portal routes here based on the available portals

    return routes;
  };

  const currentPage = window.location.pathname;
  console.log("CURRENT PAGE", currentPage);
  let showActivationPage = false;
  let showCurrentWashLocationsMap = false;
  let showSignupPage = false;
  let showSignupSuccessPage = false;
  let showSignupCancelPage = false;
  let showDefaultPage = false;
  switch (currentPage) {
    case "/activate":
      showActivationPage = true;
      break;
    case "/current-wash-locations-map":
      showCurrentWashLocationsMap = true;
      break;
    case "/signup":
      showSignupPage = true;
      break;
    case "/success":
      showSignupSuccessPage = true;
      break;
    case "/cancel":
      showSignupCancelPage = true;
      break;
    default:
      showDefaultPage = true;
      break;
  }

  const isLp =
    new URLSearchParams(window.location.search).get("isLp") === "true";
  const hidePublicChrome =
    isLp && (showSignupPage || showSignupSuccessPage || showSignupCancelPage);

  const mapEmbedAllowed = isCurrentEmbedAllowed();

  return showCurrentWashLocationsMap ? (
    mapEmbedAllowed ? (
      <CurrentWashLocationsMap />
    ) : (
      <div style={{ padding: 24, fontFamily: "Poppins, sans-serif" }}>
        This map can only be embedded from an approved Priority One site.
      </div>
    )
  ) : (
    <>
      <div
        className={
          showDefaultPage && userPortals.length > 0
            ? "flex min-h-screen flex-col"
            : undefined
        }
      >
      {!hidePublicChrome && (
        <div className="flex shrink-0 justity-between bg-[#10073E]">
          <img
            className="max-w-[480px] p-2"
            src={P1LogoLight}
            alt=""
            onClick={() => {
              window.location.href = "/";
            }}
          />
        </div>
      )}

      {/* For not logged in user, show the login button */}

      {showActivationPage && <ActivateMembershipWithInviteCode />}
      {showSignupPage && <SelfSignUpRegister />}
      {showSignupSuccessPage && <SelfSignUpSuccess />}
      {showSignupCancelPage && <SelfSignUpCancel />}
      {!user && !showActivationPage && !showSignupPage && !showSignupSuccessPage && !showSignupCancelPage && (
        <Profile
          userPortals={userPortals}
          currentPortal={currentPortal}
          setCurrentPortal={(data) => {
            setCurrentPortal(data);
          }}
        />
      )}

      {showDefaultPage && userPortals.length > 0 && (
        <div className="app-priorityone flex min-h-0 flex-1 flex-col">
          {/* {user && userPortals && <SelectPortalDD userPortals={userPortals} currentPortal={currentPortal} setCurrentPortal={(data) => { setCurrentPortal(data) }} />} */}
          <div className="app-inner flex w-full flex-1 flex-col divide-y-2 sm:flex-col">
            {!currentPortal && user && userPortals && (
              <SelectPortalModal
                userPortals={userPortals}
                setCurrentPortal={(data) => {
                  setCurrentPortal(data);
                }}
              />
            )}
            {currentPortal == "Partner" && !currentCompany && (
              <SelectCompanyModal
                setCurrentCompany={(data) => {
                  setCurrentCompany(data);
                }}
              />
            )}
            {/* {currentPortal == 'Partner' && currentCompany && <SelectCompanyDD setCurrentCompany={(data) => { setCurrentCompany(data) }} />} */}
            <div className="app-header userDropDown flex justify-between absolute top-1 right-5 max-h-[48px] bg-white">
              {/* <div className="header-logo flex justify-center items-center max-w-[250px]">
                <img
                  src={blueLogo}
                  alt=""
                  onClick={() => {
                    window.location.href = "/";
                  }}
                />
              </div> */}
              <div></div>

              {/* <div className="header-logo bg-[url('./assets/images/blueLogo.png')]">

          </div> */}
              {user && (
                <div className="flex items-center">
                  <RegionPortalSwitcher />
                  <Profile
                    userPortals={userPortals}
                    currentPortal={currentPortal}
                    setCurrentPortal={(data) => {
                      setCurrentPortal(data);
                    }}
                  />
                </div>
              )}
            </div>
            <XeroHealthBannerHost currentPortal={currentPortal} />
            <main className="flex w-full flex-1 flex-col divide-x-2 divide-slate-200 sm:flex-col md:flex-row">
              {currentUser && (
                <>
                  {user && (
                    <MainMenu
                      setCurrentMerchantStore={(data) => {
                        setCurrentMerchantStore(data);
                      }}
                      userPortals={userPortals}
                      currentPortal={currentPortal}
                      setCurrentPortal={(data) => {
                        setCurrentPortal(data);
                      }}
                      setCurrentCompany={(data) => {
                        setCurrentCompany(data);
                      }}
                    />
                  )}
                  <div className="flex min-h-0 min-w-0 flex-1 flex-col">
                    <Routes>
                      {isOffline && <Route exact path="/" element={<Maintenance ReactGA={ReactGA} GTM={TagManager} />} />}
                      <Route exact path="/" element={<Home />} />
                      {generateRoutes()}
                      {/* <Route path="*" element={<NotFound />} /> */}
                    </Routes>
                  </div>
                </>
              )}
            </main>
            <GlobalFooter />
          </div>
        </div>
      )}
      {user &&
        currentPortal === "Customer" &&
        (pendingVehicleItems.length > 0 || pendingVehicleActivationItems.length > 0) && (
          <PendingVehicleActivationModal
            key={
              pendingVehicleItems.length > 0
                ? `capture-${pendingVehicleItems[0].vehicleId}`
                : `activation-${pendingVehicleActivationItems[0].vehicleId}`
            }
            mode={pendingVehicleItems.length > 0 ? "capture" : "activation"}
            items={pendingVehicleItems.length > 0 ? pendingVehicleItems : pendingVehicleActivationItems}
            onResolved={handlePendingVehicleFlowResolved}
          />
        )}
      </div>
    </>
  );
};

export default App;
